module.exports = __webpack_public_path__ + "static/media/Scan.d3273c3c.svg";